import { render, staticRenderFns } from "./MoleculeTheModalShadow.vue?vue&type=template&id=4e4805b6"
import script from "./MoleculeTheModalShadow.vue?vue&type=script&lang=js"
export * from "./MoleculeTheModalShadow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports